import {Component, ElementRef, ViewChild} from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';


import {LicitacaoService} from '../../../../providers/licitacao-service';
import {AlertService} from '../../../../providers/alert-service';
import {MenuService} from '../../../../providers/menu-service';
import {ModulosController} from '../../modulos-controller';
import {UsuarioService} from '../../../../providers/usuario-service';
import {GestaoPcaService} from '../../../../providers/gestao-pca-service';

const Highcharts = require('highcharts');

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/drilldown')(Highcharts);

declare var require: any;

@Component({
    selector: 'page-visao-gerencial',
    templateUrl: 'visao-gerencial.html',
    providers: [
        LicitacaoService
    ]
})

export class VisaoGerencialPage extends ModulosController {
    @ViewChild('chart') public chartEl: ElementRef;

    listaDados: any = [];
    listaDadosAux: any = [];
    listaDadosElementoDespesa: any = [];
    listaDadosElementoDespesaData: any = [];
    listaDadosJson: any;

    drilldownText: any = '';

    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "62";
    options: Object;

    private _chart: any;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public licitacaoService: LicitacaoService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(7);
    }

    carregarDados() {
        this.licitacaoService.obterVisaoGerencial().subscribe(data => {

            this.listaDadosJson = data;

            if (data != null && data.modalidades != null) {

                this.listaDadosAux = data.modalidades.map((elem) => ([elem.descricao, elem.valorTotal, elem.descricao]));

                for (let i = 0; i < this.listaDadosAux.length; i++) {
                    this.listaDados.push({
                        name: this.listaDadosAux[i][0],
                        y: this.listaDadosAux[i][1],
                        drilldown: this.listaDadosAux[i][2]
                    });
                }

                this.listaDadosElementoDespesa = data.modalidades.map((elem) => ([elem.descricao, elem.elementoDespesas.map((desp) => ([desp.nome, desp.valor]))]));

                for (let i = 0; i < this.listaDadosElementoDespesa.length; i++) {

                    let data = [];

                    this.listaDadosElementoDespesa[i][1].forEach(element => {
                        data.push({
                            name: element[0],
                            y: element[1]
                        });
                    });

                    this.listaDadosElementoDespesaData.push({
                        name: this.listaDadosElementoDespesa[i][0],
                        id: this.listaDadosElementoDespesa[i][0],
                        data: data
                    });
                }

                this.carregarGrafico();
            }

            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    carregarGrafico() {

        let opts: any = {
            title: { text: 'Visão Gerencial das Licitações Realizadas' },
            subtitle: { text: 'Clique nas modalidades para ter uma visão por elemento de despesa' },
            credits: {
                enabled: false
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Volume de Recursos'
                }
            },
            xAxis: {
                type: 'category',
                labels: {
                    style: {
                        fontSize: '9px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    var seriesData = this.series.data;

                    var total = 0;
                    for (var i = 0; i < seriesData.length; i++) {
                        total += seriesData[i].y
                    }

                    return '<span style="font-size:13px">' + this.series.data[this.x].name + '</span><br><br/>' +
                        '<b>' + (100 * this.y / total).toFixed(2) + '%</b> do total<br/><br/>' +
                        '<span style="color:' + this.color + '">Valor (R$)</span>: <b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b><br/>' +
                        '<span style="color:' + this.color + '">Total (R$)</span>: <b>' + Highcharts.numberFormat(total, 2, ',', '.') + '</b><br/>';
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            var seriesData = this.series.data;

                            var total = 0;
                            for (var i = 0; i < seriesData.length; i++) {
                                total += seriesData[i].y
                            }

                            return (100 * this.y / total).toFixed(2) + "%";
                        }
                    }
                }
            },
            series: [{
                name: 'Modalidades',
                colorByPoint: true,
                data: this.listaDados
            }],
            drilldown: {
                name: "Elementos de Despesa",
                colorByPoint: true,
                series: this.listaDadosElementoDespesaData
            },
            exporting: {
                enabled: true,
                sourceWidth: 1920
            }
        };

        if (this.chartEl && this.chartEl.nativeElement) {
            opts.chart = {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                backgroundColor: 'transparent',
                events: {
                    drilldown: function (e) {
                        Highcharts.charts.forEach(function (chart) {
                            chart.setTitle(null, { text: 'Modalidade: ' + e.point.name }, true);
                        });
                    },
                    drillup: function (e) {
                        Highcharts.charts.forEach(function (chart) {
                            chart.setTitle(null, { text: 'Clique nas modalidades para ter uma visão por elemento de despesa' }, true);
                        });
                    }
                },
                renderTo: this.chartEl.nativeElement
            };

            this._chart = new Highcharts.Chart(opts);
        }

    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaLicitacao() {
        this.menuService.redirecionarPagina(this.licitacaoService.obterIdPaginaLicitacao());
    }

    submeterNoCertificado() {
        let idAnalise = "";
        this.loading = true;
        if (this.listaDadosJson.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDadosJson.resultadoAnalise == null || this.listaDadosJson.resultadoAnalise == undefined || !this.listaDadosJson.resultadoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDadosJson) {
                idAnalise = this.listaDadosJson.idModuloAnalise;
                this.licitacaoService.submeterAnaliseNoCertificadoVisao(idAnalise, this.listaDadosJson, this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaLicitacao();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    salvarComentario() {
        this.loading = true;
        if (this.listaDadosJson) {
            this.listaDadosJson.resultadoAnalise = this.capitalize(this.listaDadosJson.resultadoAnalise);
            this.licitacaoService.salvarVisaoGerencial(this.listaDadosJson, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.loading = false;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
                this.loading = false;
            });
        }
    }

    cancelarSubmeterNoCertificado() {
        this.submetendoNoCertificado = false;
        this.loading = true;
        this.carregarDados();
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/licitacao/visao-gerencial/visao-gerencial.ts